import { LoggerMessage } from './LoggerMessage';
import { InjectionKey } from 'vue';

export const loggerKey: InjectionKey<Logger> = Symbol();

export interface Logger {
  error(message: LoggerMessage, error?: Error): void;
  warn(message: LoggerMessage, error: Error): void;
}
